import React, { useState, useEffect } from 'react';
import FilterContainer from './FilterContainer';
import SearchDropdownContainer from './SearchDropdownContainer';

function FilterSearchSelect(props) {
  const {
    taxonomy,
    taxSlug,
    selected,
    displayPostCounts,
    label,
    collapsible,
    scrollable,
    dropdown,
    tooltip,
    tooltipLeftContent,
    tooltipRightContent,
    replaceSelected,
    isSelected,
    labelTitle
  } = props;

  const [filteredTaxonomy, setFilteredTaxonomy] = useState([]);
  const [search, setSearch] = useState('');
  const [closeRequest, setCloseRequest] = useState(false);
  const allTerms = [];
  let parentContent;
  let childContent;
  let filterContent;

  const runTaxSearch = async function(search = '') {
    if (search) {
      const requestURL = `${wp.home_url}/wp-json/eight29/v1/tax-search/${taxSlug}/${encodeURIComponent(search)}`;

      const response = await fetch(requestURL);
      const data = await response.json();
      if (Array.isArray(data)) {
        setFilteredTaxonomy([...data]);
      }
    } else {
      setFilteredTaxonomy([]);
    }
  }

  function clickHandler(e, object) {
    e.preventDefault();
    replaceSelected(object.id, taxSlug);

    if (isSelected(object.id, taxSlug)) {
      setSearch('');
    } else {
      setSearch(object.name);
    }
  }

  function activeButtonClass(id) {
    let classString = '';

    if(isSelected(id, taxSlug)) {
      classString = 'active';
    }

    return classString;
  }

  if (filteredTaxonomy) {
    filteredTaxonomy.forEach(term => {
      if (displayPostCounts) {
        parentContent = `${term.name} (${term.count})`;
      }
      else {
        parentContent = term.name;
      }

      allTerms.push(
        <li key={term.id}>
          <button 
            id={`${taxSlug}-${term.id}`}
            onClick={(e) => {clickHandler(e, term), setCloseRequest(true)}}
            className={activeButtonClass(term.id)}
          >
            {parentContent}
          </button>
        </li>
      )

      if (term.children) {
        term.children.forEach(child => {
          if (displayPostCounts) {
            childContent = `${child.name} (${child.count})`;
          }
          else {
            childContent = child.name;
          }

          allTerms.push(
            <li key={child.id}>
              <button 
                id={`${taxSlug}-${child.id}`}
                onClick={(e) => {clickHandler(e, child), setCloseRequest(true)}}
                className={activeButtonClass(child.id)}
              >
              {childContent}
              </button>
            </li>
          )
        });
      }
    });
  }

  if (dropdown) {
    filterContent = <SearchDropdownContainer
      search={search}
      setSearch={setSearch}
      selected={selected}
      runTaxSearch={runTaxSearch}
      replaceSelected={replaceSelected}
      taxSlug={taxSlug} 
      closeRequest={closeRequest}
      setCloseRequest={setCloseRequest}
      defaultLabel={label}
      labelTitle={labelTitle}
      >
        <ul className="dropdown-list">
          {allTerms}
        </ul>
      </SearchDropdownContainer>
  }
  else {
    filterContent = <ul>
      {allTerms}
    </ul>
  }

  return (
    <FilterContainer 
    className="filter-accordion-single-select filter-search" // TODO: update scss to include classname for filter-search-select
    label={label}
    collapsible={collapsible}
    scrollable={scrollable}
    tooltip={tooltip}
    tooltipLeftContent={tooltipLeftContent}
    tooltipRightContent={tooltipRightContent}
    labelTitle={labelTitle}
    >
      {filterContent}
    </FilterContainer>
  )
}

export default FilterSearchSelect;